<template lang="pug">
  #BindSaIndex
</template>

<script>
import { M_BIND_SA_SUCCESS } from "@/router/member/bind-sa";
import { M_CHANGE_SA_INDEX } from "@/router/member/change-sa";
import { M_PLAN_SIGN_UP, M_PLAN_SIGN_UP_2024 } from "@/router/member/trial-plan";

export default {
  name: "BindSaIndex",
  // props: {
  //   sa_id: {
  //     type: [String, Number],
  //     required: true
  //   },
  //   store_id: {
  //     type: [String, Number],
  //     required: true
  //   }
  // },
  mounted() {
    const vm = this;
    const sa_id = this.sa_id ? this.sa_id : window.sessionStorage.getItem("sa_id");
    const store_id = this.store_id
      ? this.store_id
      : window.sessionStorage.getItem("store_id");
    const action = window.sessionStorage.getItem("action"); //action -> 用來判斷從bc綁定會員卡成功之後回到的頁面，

    vm.$store.commit("toggleLoading", false);
    vm.$swal.fire({
      title: "綁定中，請稍候",
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      },
    });

    if (!sa_id && !store_id) {
      vm.$swal.fire({
        icon: "error",
        title: "綁定失敗，請重新再嘗試一次[Err1]",
        showConfirmButton: false,
        showCancelButton: false,
        allowOutsideClick: false,
      });
      return;
    }

    vm.$store
      .dispatch("member_bind_sa/memberBindingSaHandler", {
        sa_id,
        store_id,
      })
      .then((res) => {
        if (res.message === '請先加入官方帳號好友') {
          vm.$swal.fire({
            icon: 'info',
            title: '前往下一步',
            confirmButtonText: "確定",
          }).then(() => {
            location.href = `${process.env.VUE_APP_DOMAIN}/member/bind-sa?sa_id=${sa_id}&store_id=${store_id}`;
          });
          return;
        }
        if (res.message === "success") {
          vm.$swal.close();
          vm.$store.commit("member_bind_sa/setSaInfo", {
            sa: res.data.after_sa,
            store: res.data.after_store,
          });

          // 新增日期比較邏輯
          const today = new Date();
          const changeDate = new Date("2024-01-01");
          let routerName = { trial_plan: M_PLAN_SIGN_UP }; // 預設路由
          if (today >= changeDate) {
            routerName = { trial_plan: M_PLAN_SIGN_UP_2024 }; // 如果當前日期晚於或等於2024年1月1日，使用新的路由
          }

          vm.$router.push({
            name: action ? routerName[action] : M_BIND_SA_SUCCESS, // 使用更新後的路由
          });
        } else if (res.message === "進入換綁流程") {
          vm.$store.commit("member_change_sa/saveChangeSaInfo", res.data);
          vm.$swal.close();
          vm.$router.push({
            name: M_CHANGE_SA_INDEX,
          });
        } else if (res.message === "進入開通會員流程") {
          vm.$swal.close();
          const token = window.sessionStorage.getItem("data");

          const domain = `${process.env.VUE_APP_MEMBER_BIND_URL}/member/bind/ba`;
          const url = `${domain}?sa_id=${res.data.sa_id}&store_id=${res.data.store_id}&token=${token}`;
          window.location = url;
        } else {
          vm.$swal.fire({
            icon: "error",
            title: "綁定失敗，請重新再嘗試一次[Err2]",
            showConfirmButton: false,
            showCancelButton: false,
          });
        }
      });
  },
};
</script>

<style></style>
